<template>
  <div class="badges-producto" :class="wrapperClass">

    <span v-if="item.badgenuevo === true" class="badge-nuevo">
      NUEVO
    </span>

    <span v-if="isEspecial" class="badge-vino-fino">
      <i class="bx bxs-crown"></i> RECOMENDACIÓN
    </span>

    <template v-if="item.mejoresventas">
      <span v-if="isCurrentRoute('topventas', { tipoRanking: 'general' })" class="badge-vino-naranja disabled-badge">
        <i class="bx bxs-award"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° TOP VENTAS` : 'TOP VENTAS' }}
      </span>
      <router-link v-else :to="{ name: 'topventas', query: { tipoRanking: 'general' } }" class="badge-vino-naranja">
        <i class="bx bxs-award"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° TOP VENTAS` : 'TOP VENTAS' }}
      </router-link>
    </template>

    <template v-else-if="item.mejoresventaslineas">
      <span v-if="isCurrentRoute('topventaslinea', { idLinea: item.id_linea, tipoRanking: 'linea' })"
        class="badge-vino-azul disabled-badge">
        <i class="bx bxs-star"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° TOP LÍNEA` : 'TOP LÍNEA' }}
      </span>
      <router-link v-else
        :to="{ name: 'topventaslinea', query: { idLinea: item.id_linea, nombre: item.linea, tipoRanking: 'linea' } }"
        class="badge-vino-azul">
        <i class="bx bxs-star"></i>
        {{ item.posicion_ventas ? `${item.posicion_ventas}° TOP LÍNEA` : 'TOP LÍNEA' }}
      </router-link>
    </template>

  </div>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
  name: 'BadgesProducto',
  props: {
    item: { type: Object, required: true },
    // Eliminamos flex-wrap para que se apilen como en la card original
    wrapperClass: { type: String, default: '' }
  },
  setup() {
    const route = useRoute();
    function isCurrentRoute(name, query = {}) {
      if (route.name !== name) return false;
      for (const key in query) {
        if (route.query[key] != query[key]) return false;
      }
      return true;
    }
    return { isCurrentRoute };
  },
  computed: {
    isEspecial() {
      const val = this.item.especial;
      return val && val.toString().toLowerCase() !== 'false';
    }
  }
};
</script>

<style scoped src="../../../../../../css/components/DetallesProducto/badges.css"></style>